import { useState, useEffect } from 'react';
import { testimonialService, Testimonial } from '@/services/cms.service';

export const useTestimonials = () => {
  const [testimonials, setTestimonials] = useState<Testimonial[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadTestimonials = async () => {
      try {
        setLoading(true);
        console.log('📝 useTestimonials - Début du chargement des témoignages...');
        // Utiliser l'endpoint public qui retourne uniquement les témoignages validés
        // Afficher tous les témoignages validés (pas seulement ceux avec featured_on_home = true)
        // pour avoir plus de contenu sur la page d'accueil
        const data = await testimonialService.getValidated();
        console.log('📝 useTestimonials - Témoignages reçus de l\'API:', data.length);
        console.log('📝 useTestimonials - Données brutes:', data);
        
        // Filtrer côté client pour s'assurer que seuls les témoignages validés sont affichés
        // (double sécurité au cas où le backend retournerait d'autres statuts)
        const validatedOnly = data.filter(t => t.status === 'validated');
        console.log('📝 useTestimonials - Témoignages validés après filtrage:', validatedOnly.length);
        if (validatedOnly.length > 0) {
          console.log('📝 useTestimonials - Noms des clients:', validatedOnly.map(t => t.customer_name).join(', '));
        }
        
        setTestimonials(validatedOnly);
        setError(null);
      } catch (err) {
        console.error('❌ useTestimonials - Erreur lors du chargement des témoignages:', err);
        setError(err instanceof Error ? err.message : 'Erreur lors du chargement des témoignages');
      } finally {
        setLoading(false);
        console.log('📝 useTestimonials - Chargement terminé');
      }
    };

    loadTestimonials();
  }, []);

  return { testimonials, loading, error };
};

